import React, { ReactNode } from "react";
import { MonitoringPermission } from "hooks/useAccess";
import { useHasPermission } from "hooks/useHasPermission";

interface CanProps {
  permission: MonitoringPermission;
  fallback?: ReactNode;
  children: ReactNode;
}

const Can: React.FC<CanProps> = ({ permission, fallback = null, children }) => {
  const allowed = useHasPermission(permission);
  return <>{allowed ? children : fallback}</>;
};

export default Can;
